module.exports = __webpack_public_path__ + "static/media/edit-pencil-icon.d9969d68.svg";